import React, { useEffect, useState } from "react";
import styles from './login.module.scss';
import logo from '../../logo.png';
import LoadingButton from '@mui/lab/LoadingButton';
import { Alert, Typography, Button, Grid, TextField, Box } from "@mui/material";
import { ArrowSquareRight } from 'iconsax-react';
import LoginUiStore from "./login-ui-store";
import LoginSchema from "../shared/forms-schemas/login-schema";
import { useFormik } from 'formik';
import PasswordField from "../shared/components/password-field";
import { useParams } from "react-router";

const uiStore = new LoginUiStore();

const Login = ({ history, context, location }) => {
    const { submitData, error } = uiStore;
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showConfirmMessage, setShowConfirmMessage] = useState(false);
    const [loading, setLoading] = useState(false);
    const { email, code } = useParams();

    const url = new URLSearchParams(location?.search);
    const redirect = url.get('redirect');

    const formik = useFormik({
        initialValues: {
            email: '',
            password: ''
        },
        validationSchema: LoginSchema,
        onSubmit: async (values) => {
            setLoading(true);
            const response = await submitData(values);
            setLoading(false);
            if (response) {
                if (redirect && redirect !== 'null')
                    history.push(redirect);
                else
                    history.push('/dashboard');

                context.actions.signIn(
                    response.firstName,
                    response.token,
                    response._id
                );
            }
        },
    });

    useEffect(() => {
        if (context.authenticatedUser?.id) {
            history.push('/dashboard');
        }

        const url = new URL(window.location.toString());
        if (url.searchParams.get("success")) {
            setShowSuccessMessage(true);
            const url = new URL(window.location.toString());
            url.searchParams.delete('success');
            window.history.pushState({}, '', url.toString());
        }
    }, [context, history]);

    useEffect(() => {

        async function confirmEmail() {
            if (await uiStore.confirmEmail(email, code))
                setShowConfirmMessage(true);
        }

        if (code && email) {
            confirmEmail()
        }

    }, [code, email])

    return (
        <Grid container>
            <Grid sx={{ backgroundColor: '#FFF' }} item xl={6} lg={6} md={12} sm={12} xs={12}>
                <Box className={styles.formContainer} >
                    <Box className={styles.headerLogo}>
                        <a href="/">
                            <img className="logo" src={logo} alt='logo' />
                        </a>
                    </Box>

                    <Box className={styles.heading}>
                        <Typography variant="h3" color="#242333" sx={{ mb: 1, fontWeight: '600' }}>Login</Typography>
                        <Typography variant="p" color="#888888" >Start creating your cards now</Typography>
                    </Box>

                    {error &&
                        <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
                    }

                    {showSuccessMessage &&
                        <Alert severity="success">Account was created successfully. Please confirm your email before logging in.</Alert>
                    }

                    {showConfirmMessage &&
                        <Alert severity="success">Your Email has been confirmed. You can log in now</Alert>
                    }

                    <Box
                        component="form"
                        className={styles.formBox}
                        onSubmit={formik.handleSubmit}
                    >
                        <TextField
                            required
                            id="email"
                            label="Email Address"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.email && Boolean(formik.errors.email)}
                            helperText={formik.touched.email && formik.errors.email}
                        />

                        <PasswordField
                            required
                            id="password"
                            label="Password"
                            formik={formik}
                        />

                        <LoadingButton
                            variant="contained"
                            color="secondary"
                            loading={loading}
                            endIcon={
                                <ArrowSquareRight
                                    size="24"
                                    color="#FFFFFF"
                                    variant="Bulk"
                                />
                            }
                            disableElevation
                            className={styles.loginbtn}
                            type='submit'
                        >
                            Login
                        </LoadingButton>

                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', mt: "5vh" }}>
                        <Button href='/forgot-password' color="grey" sx={{ p: 1 }} size='small'>Forgot Your Password?</Button>
                        <Button color="grey" href={'/register?redirect=' + redirect} sx={{ p: 1 }} size='small'>Don't Have an account yet?
                            <Typography color='#242333' variant="p" sx={{ ml: 2 }}> Register</Typography>
                        </Button>
                    </Box>
                </Box>
            </Grid>
            <Grid className={styles.gradiantBackground} item xl={6} lg={6} display={{ lg: "block", md: "none", sm: "none", xs: "none" }}>

                <Box className={styles.imgbackground}>
                    <Typography variant="h3" color="white" sx={{ mb: 1, fontWeight: '700', textAlign: 'center' }}>Stay in touch </Typography>
                    <Typography variant="h3" color="white" sx={{ mb: 1, fontWeight: '200', textAlign: 'center' }}>with your community</Typography>
                </Box>
            </Grid>
        </Grid>
    );

}

export default Login;